import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { SVGFC } from '@repo/toolkit/types'
import Typography from '@repo/ui/typography'

type ClientHeaderProps = {
  title: string
  icon: SVGFC
}

export function ClientHeader({ title, icon: Icon }: ClientHeaderProps) {
  return (
    <div className="flex items-center gap-2">
      <div className="w-10 h-10 bg-primary-light rounded flex items-center justify-center">
        <Icon color={tailwindColors.primary.dark.DEFAULT} className="w-8 h-8" />
      </div>
      <Typography variant="h3" color={tailwindColors.primary.dark.DEFAULT}>
        {title}
      </Typography>
    </div>
  )
}
